













































import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class UnlockPrescriptionDialog extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  opcaoExcluir;

  dialogFlag = false;
  formOpen = false;
  group = [];
  ids = [];
  loadingGroup = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo']
  };

  public form: any = {
    valid: false
  };

  public beforeMount(): void {
    const filter = {
      idMedico: this.item.medico.id,
      idUnidade: this.item.unidade.id
    };

    this.loadGroup();
  }

  private loadGroup() {
    this.loadingGroup = true;
    service.getUnlockPrescriptionGroup(this.item.idPrescricao).subscribe(
      (res) => {
        this.loadingGroup = false;
        this.group = res;
      },
      (error) => {
        this.loadingGroup = false;
        this.showToastApiError(error);
      }
    );
  }

  mounted() {
    this.formOpen = true;
  }

  private getLabelBotaoQtdePresc() {
    if ((this.item && this.item.quantidade && this.item.quantidade > 1) || this.ids.length) {
      return ` ( ${this.item.quantidade * (this.ids.length + 1)} Prescrições )`;
    }
    return '';
  }

  public unlockPrescription(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Desbloqueando ...');

    var observable = null;
    let parm = new service.PrescricaoDesbloqueioParmDTO();
    parm.idsPrescricao = Object.assign(new Array(), this.ids);
    parm.idsPrescricao.push(this.item.idPrescricao);
    observable = service.unlockPrescriptions(parm);
    this.addSubsc(
      observable.subscribe(
        (data) => {
          this.loader.stop();
          this.closeForm();
          this.$emit('unlockPrescription');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      )
    );
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  selectAll() {
    this.ids = this.group.map((g) => g.id);
  }

  removeAllSelected() {
    this.ids = [];
  }
}
